<div class="flightScaleTableDs__cont">
  <div
    class="flightScaleTableDs__cont__table"
    (click)="clickEvent.emit()">
    <div class="flightScaleTableDs__cont__table__itinerary-info">
      <div class="airline-info airline-info--{{size}}">
        <div class="airline-logo">
          <app-ds-image
            [src]="airlineLogo"
            [objectFit]="'contain'"
            [alt]="airlineName">
          </app-ds-image>
        </div>
        <div class="airline-name airline-name--{{size}}" *ngIf="isRegular">
          <app-ds-typography
            [size]="xxsFontSize"
            [text]="airlineName"
            [color]="secondaryTextColor"
            [ellipsis]="true">
          </app-ds-typography>
        </div>
      </div>
      <div class="timer-cont timer-cont--{{size}}">
        <div class="departure-info departure-info--{{size}}">
          <div class="time">
            <app-ds-typography
              [fontFamily]="semiBoldFontFamily"
              [size]="xsFontSize"
              [text]="departureTime"
              [color]="primaryTextColor">
            </app-ds-typography>
          </div>
          <div class="iata-code" *ngIf="!isRegular">
            <app-ds-typography
              [size]="xxxsFontSize"
              [text]="departurePointCode"
              [color]="secondaryTextColor">
            </app-ds-typography>
          </div>
        </div>
        <div class="stops stops--{{size}}">
          <ng-container *ngIf="isTiny">
            <div class="scales">
              <app-ds-flight-scale
                [stops]="stops"
                [size]="smallScale">
              </app-ds-flight-scale>
            </div>
          </ng-container>
          <ng-container *ngIf="!isTiny">
            <app-ds-flight-duration
              [flightTime]="flightTime"
              [stops]="stops"
              [stopsLabel]="stopsLabel">
            </app-ds-flight-duration>
          </ng-container>
        </div>
        <div class="arrival-info arrival-info--{{size}}">
          <div class="time">
            <app-ds-typography
              [fontFamily]="semiBoldFontFamily"
              [size]="xsFontSize"
              [text]="arrivalTime"
              [color]="primaryTextColor">
            </app-ds-typography>
            <div class="extra-days" *ngIf="daysDifference">
              <div class="count">
                <app-ds-typography
                  [size]="minorFontSize"
                  [text]="daysDifference"
                  [color]="secondaryTextColor">
                </app-ds-typography>
              </div>
            </div>
          </div>
          <div class="iata-code" *ngIf="!isRegular">
            <app-ds-typography
              [size]="xxxsFontSize"
              [text]="arrivalPointCode"
              [color]="secondaryTextColor">
            </app-ds-typography>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="!isTiny">
      <div class="flightScaleTableDs__cont__table__luggage-info flightScaleTableDs__cont__table__luggage-info--{{size}}">
        <div class="luggage-info-cont">
          <div class="airline-name" *ngIf="isMedium">
            <app-ds-typography
              [size]="xxxsFontSize"
              [text]="airlineName"
              [color]="secondaryTextColor"
              [ellipsis]="true">
            </app-ds-typography>
          </div>
          <ng-container *ngTemplateOutlet="luggageCategories"></ng-container>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="isTiny">
      <ng-content></ng-content>
    </ng-container>
  </div>
  <div class="flightScaleTableDs__cont__table footer" *ngIf="isSmall">
    <div class="flightScaleTableDs__cont__table__stop-timer">
      <div class="stop-label">
        <app-ds-typography
          [size]="minorFontSize"
          [text]="stopsLabel"
          [color]="primaryTextColor">
        </app-ds-typography>
      </div>
      <div class="flight-time">
        <app-ds-typography
          [size]="minorFontSize"
          [text]="flightTime"
          [color]="secondaryTextColor">
        </app-ds-typography>
      </div>
    </div>
    <div class="flightScaleTableDs__cont__table__luggage-info flightScaleTableDs__cont__table__luggage-info--{{size}}">
      <div class="airline-name">
        <app-ds-typography
          [size]="xxxsFontSize"
          [text]="airlineName"
          [color]="secondaryTextColor"
          [ellipsis]="true">
        </app-ds-typography>
      </div>
      <ng-container *ngTemplateOutlet="luggageCategories"></ng-container>
    </div>
  </div>
</div>

<ng-template #luggageCategories>
  <div
    class="luggageCategories__cont luggageCategories__cont--{{size}}"
    (mouseenter)="lugaggerHover.emit({ enter: true, leave: false })"
    (mouseleave)="lugaggerHover.emit({ enter: false, leave: true })">
    <div class=""></div>
    <app-ds-icon
      class="icon"
      [color]="getIconFillColor(baggage?.PersonalItem)"
      [icon]="backpack"
      [size]="14">
    </app-ds-icon>
    <app-ds-icon
      class="icon"
      [color]="getIconFillColor(baggage?.CabinbBaggage)"
      [icon]="handLuggage"
      [size]="14">
    </app-ds-icon>
    <app-ds-icon
      class="icon last"
      [color]="getIconFillColor(baggage?.CheckedBaggage)"
      [icon]="luggage"
      [size]="14">
    </app-ds-icon>
  </div>
</ng-template>